"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _PreviewObject = _interopRequireDefault(require("./PreviewObject"));

var _PreviewArray = _interopRequireDefault(require("./PreviewArray"));

var _PreviewString = _interopRequireDefault(require("./PreviewString"));

var _PreviewNumber = _interopRequireDefault(require("./PreviewNumber"));

var _PreviewBoolean = _interopRequireDefault(require("./PreviewBoolean"));

var _PreviewLocalizedString = _interopRequireDefault(require("./PreviewLocalizedString"));

var _PreviewReference = _interopRequireDefault(require("./PreviewReference"));

var _PreviewReferenceArray = _interopRequireDefault(require("./PreviewReferenceArray"));

var _PreviewMediaArray = _interopRequireDefault(require("./PreviewMediaArray"));

var _PreviewMedia = _interopRequireDefault(require("./PreviewMedia/"));

var _utils = require("../Schema/utils");

require("./PreviewField.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const templates = {
  "object": _PreviewObject.default,
  "array": _PreviewArray.default,
  "string": _PreviewString.default,
  "number": _PreviewNumber.default,
  "integer": _PreviewNumber.default,
  "boolean": _PreviewBoolean.default,
  "localizedString": _PreviewLocalizedString.default,
  "reference": _PreviewReference.default,
  "referenceArray": _PreviewReferenceArray.default,
  "mediaArray": _PreviewMediaArray.default,
  "media": _PreviewMedia.default
};

class PreviewField extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderChild", (name, index) => {});

    _defineProperty(this, "getClassName", () => {
      let classNames = [];
      classNames.push('admin-preview__field');
      const template = this.getTemplate();

      if (template) {
        classNames.push('field--' + template);
      }

      return classNames.join(' ');
    });

    _defineProperty(this, "getTemplate", () => {
      const schema = this.props.schema;
      let template;

      if ((0, _utils.isMediaObject)(schema)) {
        template = "media";
      } else if (schema.type === "array" && (0, _utils.isMediaObject)(schema.items)) {
        template = "mediaArray";
      } else if ((0, _utils.isReferenceObject)(schema)) {
        template = "reference";
      } else if (schema.type === "array" && (0, _utils.isReferenceObject)(schema.items)) {
        template = "referenceArray";
      } else if ((0, _utils.isLocalizedString)(schema)) {
        template = "localizedString";
      } else if (schema && schema.type) {
        template = schema.type;
      }

      return template;
    });
  }

  render() {
    const _this$props = this.props,
          id = _this$props.id,
          schema = _this$props.schema,
          formData = _this$props.formData;
    const className = this.getClassName();
    const template = this.getTemplate();

    if (template && templates[template]) {
      const FieldTemplate = templates[template];
      return _react.default.createElement(FieldTemplate, _extends({}, this.props, {
        className: className
      }), this.props.children);
    }

    return this.props.children;
  }

}

var _default = PreviewField;
exports.default = _default;
module.exports = exports.default;